<template>
  <div
    class="loading"
    :style="{ background: `linear-gradient(0deg, #0487a3, #0b3277 ${currentGradientPercentage}%)` }">
    <div class="loading__status">
      <div class="loading__status__current">{{ (animatedPercentage).toFixed(0) }}</div>
      <div
        class="loading__status__bar"
        :style="{ transform: `scale(${slicedCurrentPercentage / 100})` }"></div>
      <div class="loading__status__max">100</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { tween } from 'popmotion'
import bgList from './SingleView/bgList'
import backgrounds from './SingleView/backgrounds'

export default {
  mixins: [ backgrounds ],
  data: () => ({
    currentTime: 0,
    minLoadingTime: 2500,
    fakeTimer: undefined,
    currentStatus: 0,
    currentGradientPercentage: 0,
    animatedPercentage: 0
  }),
  computed: {
    slicedCurrentPercentage: {
      get () {
        return Math.round(Math.min(this.currentTime * 100 / this.minLoadingTime, this.currentPercentage))
      }
    },
    currentPercentage: {
      get () {
        return Math.round(this.currentStatus * 100 / this.loadingObjects.length)
      }
    },
    loadingObjects: {
      get () {
        return _.map(_.keys(bgList), this.$_nearestBackground)
      }
    }
  },
  async mounted () {
    this.$_runFakeTimer()
    await Promise.all([this.$_getFakeTimer(this.minLoadingTime), this.$_loadAll()])
    this.currentStatus = this.loadingObjects.length
    window.setTimeout(() => {
      this.$router.push({ name: 'landing' })
    }, 500)
  },
  methods: {
    $_loadAll () {
      return Promise.all(_.map(this.loadingObjects, obj => this.$_load(obj).then(() => { this.currentStatus++ })))
    },
    $_load (source) {
      return new Promise((resolve, reject) => {
        const image = new window.Image()
        image.addEventListener('load', resolve)
        image.setAttribute('src', source)
      })
    },
    $_getFakeTimer (time = 5000) {
      return new Promise((resolve, reject) => window.setTimeout(resolve, time))
    },
    $_runFakeTimer () {
      this.currentTime = 0
      const startTime = Date.now()
      const slicedTime = this.minLoadingTime / 10
      this.fakeTimer = window.setInterval(() => {
        this.currentTime = Date.now() - startTime
      }, slicedTime)
    }
  },
  watch: {
    slicedCurrentPercentage: {
      handler (current, prev) {
        tween({
          from: prev * 2.5,
          to: current * 2.5,
          duration: 500
        }).start(value => { this.currentGradientPercentage = value })

        tween({
          from: prev,
          to: current,
          duration: 500
        }).start(value => { this.animatedPercentage = value })
      }
    }
  }
}
</script>

<style>
.loading {
  position: absolute;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
}

.loading__status {
  color: white;
}

.loading__status {
  display: flex;
  align-items: center;
  transform: translate3d(0, 0, 0);
  justify-content: center;
  position: relative;
  width: 50%;
}

.loading__status__current, .loading__status__max {
  min-width: 2.2rem;
}

.loading__status__bar {
  height: 1px;
  background-color: white;
  transform: scale(0) translate3d(0, 0, 0);
  transform-origin: left;
  transition: transform .3s;
  width: 100px;
  margin: 0 2.5%;
}
</style>
